/**
 * 组件构造
 * @constructor
 * @classdesc 请求对象
 * @alias G.base.IHttpRequest
 * @returns {G.base.IHttpRequest} 实例化对象
 */
class IHttpRequest {
    constructor(opts) {}

    /**
     * Get 请求
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     * @param headers
     */
    get(url, responseType, data, contentType, headers) {}

    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     * @param headers
     */
    post(url, responseType, data, contentType, headers) {}


    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     * @param headers
     */
    put(url, responseType, data, contentType, headers) {}


    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     * @param headers
     */
    delete(url, responseType, data, contentType, headers) {}
}

module.exports = IHttpRequest;